import { PRESET_THEMES } from "@/src/constants/appearance";
import { useTranslation } from "react-i18next";
import { View } from "react-native";
import ScButton from "../../ui-kit/button";
import SectionHeader from "../../ui-kit/section-header";
import ThemeTile from "./preset-theme-tile";

export type PresetTheme = Readonly<{
  id: string;
  name: string;
  color: string;
}>;

type PresetThemesSectionProps = Readonly<{
  selectedTheme: string | null;
  savedTheme: string | null;
  onSelect: (id: string) => void;
  onApply: () => void;
}>;

const PresetThemesSection = ({
  selectedTheme,
  savedTheme,
  onSelect,
  onApply,
}: PresetThemesSectionProps) => {
  const { t } = useTranslation();
  return (
    <View className="gap-4">
      <View className="flex-col md:flex-row md:items-center md:justify-between gap-3">
        <SectionHeader
          title={t("LABEL_PRESET_THEMES")}
          subtitle={t("LABEL_PRESET_THEMES_DESC")}
        />
        {selectedTheme !== savedTheme && (
          <View className="w-full md:w-32">
            <ScButton mode="outlined" text="BTN_APPLY" onPress={onApply} />
          </View>
        )}
      </View>
      <View className="flex-row flex-wrap justify-center md:justify-between gap-4">
        {PRESET_THEMES.map((theme) => (
          <ThemeTile
            key={theme.id}
            theme={theme}
            isSelected={selectedTheme === theme.id}
            isSaved={savedTheme === theme.id}
            onPress={() => onSelect(theme.id)}
          />
        ))}
      </View>
    </View>
  );
};

export default PresetThemesSection;
